import React from 'react';
function PageUndefind(){
  return(
    <p>无权限</p>
  )
}
export default PageUndefind